import { create } from 'zustand';

export type OrgRole = 'owner' | 'admin' | 'member' | 'sales_manager' | 'sales_rep';

interface CrmRoleState {
  role: OrgRole | null;
  setRole: (r: OrgRole | null) => void;
}

export const useCrmRoleStore = create<CrmRoleState>((set) => ({
  role: null,
  setRole: (r) => set({ role: r })
}));

export function isManager(role: OrgRole | null): boolean {
  return role === 'owner' || role === 'admin' || role === 'sales_manager';
}
